export default __webpack_public_path__ + "static/0215-44feeb31755f39097baed0c9721259a1.png";